import { Flex } from '@uhg-abyss/web/ui/Flex';
import { t } from 'i18next';
import { Fragment } from 'react';

import { shouldUseGehaV2Styling } from '../../../../utils/gehaThemeUtils';
import {
  SuggestioContentModal,
  SuggestionHeading,
  UnOrderList,
} from './PatientReviews.styled';

type Props = {
  heading: string;
  surveyAnswers: any;
  showItem: boolean;
  answersType: string;
};

export const PatientReviewSuggestionCard = ({
  heading,
  surveyAnswers,
  showItem,
  answersType,
}: Props) => {
  const surveys = Object.entries(surveyAnswers).filter(
    ([, value]) => value === showItem
  );

  const isGEHAV2 = shouldUseGehaV2Styling();

  return (
    <Flex css={{ gap: '12px' }} direction={'column'}>
      <SuggestionHeading cssProps={{ isGEHAV2 }} level={3} size="xs">
        {heading}
      </SuggestionHeading>
      {surveys.length ? (
        <UnOrderList>
          {surveys.map(([keyName, value], i) => (
            <Fragment key={i}>
              {showItem === value ? (
                <li key={i}>
                  <SuggestioContentModal cssProps={{ isGEHAV2 }} size={'$sm'}>
                    {t(keyName + answersType)}
                  </SuggestioContentModal>
                </li>
              ) : null}
            </Fragment>
          ))}
        </UnOrderList>
      ) : (
        <SuggestioContentModal cssProps={{ isGEHAV2 }} size="$md">
          {t('No Results')}
        </SuggestioContentModal>
      )}
    </Flex>
  );
};
